"use strict";
/**
 * Shift Checklist Response Types
 *
 * Response DTOs for the shift checklist endpoints. Dates are ISO 8601 strings.
 * Model (GH#454): the day view is run-less — activities + their matrix status.
 */
Object.defineProperty(exports, "__esModule", { value: true });
